import * as systemUtils from "./utils/systemUtils";

// Keys that accept arrays.
const tagParametersGlobal = "global parameters";
const tagParameters = "parameters";
const tagFunctions = "functions";
const tagChoices = "choices";
const tagConditions = "logic";
// Keys that accept primitives.
const tagParameterOutput = "default value";
const tagParameterTarget = "linked to";
const tagChoiceValue = "value";
const tagConditionExpression = "expression";
const tagNodeLabel = "labels";
// Metadata.
const tagMetaComment = "comment";

//------------------------------------------------------------------------
// GETTERS - TAGS
//------------------------------------------------------------------------

export const getTagGlobals = () => {
  return tagParametersGlobal;
};

export const getTagFunctions = () => {
  return tagFunctions;
};

export const getTagParameters = () => {
  return tagParameters;
};

export const getTagChoices = () => {
  return tagChoices;
};

export const getTagConditions = () => {
  return tagConditions;
};

export const getTagChoiceValue = () => {
  return tagChoiceValue;
};

export const getTagParameterOutput = () => {
  return tagParameterOutput;
};

export const getTagParameterTarget = () => {
  return tagParameterTarget;
};

export const getTagExpressions = () => {
  return tagConditionExpression;
};

export const getTagLabel = () => {
  return tagNodeLabel;
};

export const getTagComment = () => {
  return tagMetaComment;
};

//------------------------------------------------------------------------
// GETTERS/SETTERS
//------------------------------------------------------------------------

export const setLabel = (node, label) => {
  set(node, tagNodeLabel, label);
};

export const setComment = (node, comment) => {
  setMeta(node, tagMetaComment, comment);
};

export const setValue = (choice, value) => {
  set(choice, tagChoiceValue, value);
};

export const setIdTarget = (parameter, idTarget) => {
  set(parameter, tagParameterTarget, idTarget);
};

export const setValueDefault = (parameter, valueDefault) => {
  set(parameter, tagParameterOutput, valueDefault);
};

export const setGlobalParameters = (container, parameters) => {
  setRefArray(container, tagParametersGlobal, parameters);
};

export const setFunctions = (root, functions) => {
  setRefArray(root, tagFunctions, functions);
};

export const setConditions = (container, conditions) => {
  setRefArray(container, tagConditions, conditions);
};

export const setExpression = (condition, expressions) => {
  set(condition, tagConditionExpression, expressions);
};

export const setParameters = (container, parameters) => {
  setRefArray(container, tagParameters, parameters);
};

export const setChoices = (container, choices) => {
  setRefArray(container, tagChoices, choices);
};

//------------------------------------------------------------------------

const set = (node, type, value) => {
  if (value === null) {
    delete node[type];

    return;
  }

  node[type] = value;
};

const setRefArray = (node, type, value) => {
  if (value === null) {
    delete node[type];

    return;
  }

  if (!systemUtils.isArray(value)) {
    throw new Error("The value must be an array.");
  }

  if (value.length === 0) {
    delete node[type];
  } else {
    if (!node[type] || !systemUtils.isArray(node[type])) {
      node[type] = value;
    } else {
      node[type].splice(0, node[type].length, ...value);
    }
  }
};

const setMeta = (node, type, value) => {

  if (!value) {
    return;
  }

  if (!node.metadata) {
    node.metadata = {};
  }

  node.metadata[type] = value;
}